<div
  class="volume-button-container"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
  (focusin)="showTooltip()"
  (focusout)="hideTooltip()">
  <button
    #volumeButton
    type="button"
    class="btn viewer-controller-icon-btn btn-volume"
    aria-label="Mute/Unmute"
    (click)="toggleMute.emit()">
    <img
      [hidden]="!(muted || volume === 0)"
      src="/assets/svg/subsection/muted.svg"
      alt="Unmute"
      width="12"
      height="14" />
    <img
      [hidden]="!(volume > 0 && volume < 0.3) || muted"
      src="/assets/svg/subsection/volume-small.svg"
      alt="Mute"
      width="12"
      height="14" />
    <img
      [hidden]="!(volume >= 0.3 && volume < 0.7) || muted"
      src="/assets/svg/subsection/volume-medium.svg"
      alt="Mute"
      width="15"
      height="14" />
    <img
      [hidden]="!(volume >= 0.7) || muted"
      src="/assets/svg/subsection/volume-large.svg"
      alt="Mute"
      width="18"
      height="14" />
  </button>

  <div class="volume-slider-wrapper">
    <div class="volume-slider" #sliderTrack (mousedown)="onTrackMouseDown($event)">
      <div class="volume-slider__fill" [style.width.%]="fillPercent"></div>
      <img
        src="/assets/svg/subsection/track.svg"
        alt="slider thumb"
        class="volume-slider__thumb"
        [style.left.%]="fillPercent" />
    </div>
  </div>
</div>
